import { NpcPointStrategy } from "./InteractionPointPreview";
import NpcPointPreview from "./NpcPointPreview";
import { Viewport3DLayerProps } from "./Viewport3DEnvironmentMetadata";
import { selectSelectedTake3D } from "../../app/slices/TrainingSlice";
import { useSelector } from "react-redux";

export default function Viewport3DNpcLayer(props: Viewport3DLayerProps) {
  const {
    currentTakeLocation,
    takePositions,
    isCameraSelected,
    collapsedTakeLocationIds = [],
  } = { ...props };
  const situationsInTake = useSelector(selectSelectedTake3D)?.situations;

  const npcs = takePositions
    .filter((pos) => situationsInTake && !(pos.id in situationsInTake))
    .filter((pos) => !collapsedTakeLocationIds.includes(pos.id))
    .map((point, index) => {
      return point.actor_positions.map((actorPos, index) => {
        return (
          <NpcPointPreview
            animateFrom={point.id !== currentTakeLocation?.id ? { ...point.position, id: point.id } : undefined}
            strategy={NpcPointStrategy}
            x={actorPos.position.x}
            y={actorPos.position.y}
            positionId={actorPos.id}
            positionDirection={actorPos.direction}
            takeColor={point.take_color}
            key={actorPos.id}
            disabled={isCameraSelected}
          />
        );
      });
    });

  return <>{currentTakeLocation && npcs}</>;
}
